module.exports = __webpack_public_path__ + "img/slider__arrow__white.de4e2d8f.svg";